import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Skeleton,
  Tbody,
  Box,
  Heading,
} from "@chakra-ui/react";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { GrEdit } from "react-icons/gr";
import TdType from "../Common/Table/TdType";
import CustomTBody from "../Common/Table/CustomTBody";
import useFetch from "../../hooks/useFetch";

const StockTable = () => {
  const history = useHistory();
  moment.locale();
  let params = useParams().state;
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { get } = useFetch();

  useEffect(() => {
    get("/products?minstock")
      .then(async (res) => {
        setProducts(res.products);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const createRows = () => {
    let formattedRows = products.map((product) => {
      return [
        {
          item: <TdType text={product.id} />,
        },
        {
          item: <TdType text={product.brand + " " + product.name} />,
        },
        {
          item: (
            <TdType
              text={`${product.category ? product.category : ""} ${
                product.subCategory ? product.subCategory : ""
              }`}
            />
          ),
        },
        {
          item: <TdType text={`${product.stock}`} />,
        },
        {
          item: <TdType text={`${product.minStock}`} />,
        },
        {
          tdStyle: { textAlign: "center" },
          item: (
            <TdType inputType="switch" id="active" isChecked={product.active} />
          ),
        },
        {
          item: (
            <TdType
              inputType="icon"
              onClick={() =>
                history.push(`/articulos/${product.id}`, {
                  prevPath: params,
                })
              }
              icon={GrEdit}
              title="Editar"
            />
          ),
        },
      ];
    });
    return formattedRows;
  };

  const createSkeleton = () => {
    let skeleton = [];
    for (let index = 0; index < 7; index++) {
      skeleton.push({ item: <Skeleton height="1rem" /> });
    }
    return skeleton;
  };

  return (
    <Box overflowX={"scroll"} pb={"0.5rem"}>
      <Heading variant="h1" mb="1rem">
        Artículos con stock crítico
      </Heading>
      <Table variant="striped" colorScheme="gray" fontSize="0.8em">
        <Thead>
          <Tr>
            <Th fontSize="0.8em">Id</Th>
            <Th fontSize="0.8em">Artículo</Th>
            <Th fontSize="0.8em">Categorías </Th>
            <Th fontSize="0.8em">Stock </Th>
            <Th fontSize="0.8em">Stock Mín.</Th>
            <Th fontSize="0.8em" textAlign="center">
              Activo
            </Th>
            <Th fontSize="0.8em" textAlign="center">
              Editar
            </Th>
          </Tr>
        </Thead>
        {isLoading ? (
          <CustomTBody rows={[createSkeleton()]} />
        ) : products.length ? (
          <CustomTBody rows={createRows()} />
        ) : (
          <Tbody>
            <Tr>
              <Td colSpan="100%">
                <Box padding="1rem 0">No se encontraron resultados</Box>
              </Td>
            </Tr>
          </Tbody>
        )}
      </Table>
    </Box>
  );
};

export default StockTable;
